<template>
  <div class="laya-lb-plyr-vimeo-view">
    <div :id="playerId" data-plyr-provider="vimeo" :data-plyr-embed-id="vimeoId">
    </div>
    <button type="button"
            class="btn btn-primary mt-3 d-block ml-auto"
            @click="onFinish[0]() || {}">
      {{ i18n.next }} <i class="fas fa-arrow-right"></i>
    </button>
  </div>
</template>

<script>
import Plyr from "plyr"
import "plyr/dist/plyr.css"
import * as i18n from '@/i18n/plugins';

export default {
  name: "laya-plyr-vimeo",
  data() {
    return {
      plyr: null
    }
  },
  mounted() {
    const vue = this
    vue.plyr = new Plyr(`#${vue.playerId}`)
    //vue.plyr.on("ended", e => vue.onFinish[0]())
  },
  props: {
    url: String,
    onFinish: Array
  },
  computed: {
    i18n: function () {
      return i18n[this.$store.state.profile.lang]
    },
    playerId: function() {
      return `ly-plyr-vimeo-${Date.now()}`
    },
    vimeoId: function() {
      let id = this.url
      if(/http/.test(id)) {
        let arr = id.split("/")
        id = arr[arr.length-1]
      }
      return parseInt(id)
    }
  },
  methods: {
  },
}
</script>

<style>
</style>
